var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M931.5,438.3H561.7V68.5c0-34-27.6-61.6-61.6-61.6s-61.6,27.6-61.6,61.6v369.8H68.7c-34,0-61.6,27.6-61.6,61.6 s27.6,61.6,61.6,61.6h369.8v369.8c0,34.1,27.6,61.6,61.6,61.6s61.6-27.6,61.6-61.6V561.6h369.8c34.1,0,61.6-27.6,61.6-61.6 S965.6,438.3,931.5,438.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlack);
export default __webpack_public_path__ + "static/media/plus-black.18302825adc444c45b7e0044aea2e199.svg";
export { ForwardRef as ReactComponent };